// State-level SEO landing page data for Excelence Inc.
// Each entry powers a unique high-intent landing page at /car-shipping-<slug>.

export const STATE_PAGES = [
  {
    slug: 'texas',
    name: 'Texas',
    abbr: 'TX',
    intro:
      'From Dallas to Houston, Austin to San Antonio — Excelence Inc is the go-to nationwide auto transport partner for Texans. Whether you\u2019re a dealer moving auction inventory or a family relocating across the country, we deliver on time, with full transparency.',
    cities: ['Dallas', 'Houston', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Arlington', 'Plano'],
    routes: [
      { from: 'Texas', to: 'Florida', miles: '~1,200', days: '2–4' },
      { from: 'Texas', to: 'California', miles: '~1,500', days: '3–5' },
      { from: 'Texas', to: 'New York', miles: '~1,750', days: '4–6' },
      { from: 'Texas', to: 'Illinois', miles: '~950', days: '2–3' },
      { from: 'Texas', to: 'Georgia', miles: '~800', days: '2–3' },
    ],
    faqs: [
      {
        q: 'How much does it cost to ship a car to or from Texas?',
        a: 'Typical rates for Texas auto transport range from $600–$1,400 depending on distance, trailer type and vehicle class. Our instant quote calculator gives you an accurate estimate in under 60 seconds.',
      },
      {
        q: 'How long does car shipping take from Texas to other states?',
        a: 'Most Texas-based shipments deliver within 2–5 days for medium distances and 4–7 days for coast-to-coast routes. Expedited service reduces these timelines.',
      },
      {
        q: 'Do you offer enclosed transport in Texas?',
        a: 'Yes. Excelence Inc offers both open and enclosed car transport across all Texas metros, including climate-controlled trailers for exotics, classics and luxury vehicles.',
      },
      {
        q: 'Do you serve Texas auction pickups?',
        a: 'Yes — we are preferred carriers for Copart and IAA auction releases throughout Texas and specialize in same-day dispatch.',
      },
    ],
  },
  {
    slug: 'florida',
    name: 'Florida',
    abbr: 'FL',
    intro:
      'Miami, Orlando, Tampa, Jacksonville — Florida is one of our busiest auto transport lanes year-round, especially for snowbirds heading south in fall and returning north in spring. Excelence Inc handles it all with professional carriers and guaranteed pickup windows.',
    cities: ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Tallahassee', 'Fort Myers'],
    routes: [
      { from: 'Florida', to: 'New York', miles: '~1,280', days: '3–5' },
      { from: 'Florida', to: 'Texas', miles: '~1,200', days: '2–4' },
      { from: 'Florida', to: 'California', miles: '~2,700', days: '7–9' },
      { from: 'Florida', to: 'Illinois', miles: '~1,200', days: '3–5' },
      { from: 'Florida', to: 'Georgia', miles: '~350', days: '1–2' },
    ],
    faqs: [
      {
        q: 'How much does snowbird car shipping to Florida cost?',
        a: 'Seasonal snowbird car shipping from Northeast states to Florida typically ranges $700–$1,200 for open transport. Book early in October for the best rates — capacity tightens sharply between November and January.',
      },
      {
        q: 'Do you ship cars from Florida to New York?',
        a: 'Yes — Florida to New York is one of our most active lanes with weekly dispatch windows in both directions. Typical transit time is 3–5 days door-to-door.',
      },
      {
        q: 'Can you ship luxury cars to Miami?',
        a: 'Absolutely. We specialize in enclosed transport for exotic, luxury and classic vehicles across all Florida markets, including Miami, Palm Beach and Naples.',
      },
      {
        q: 'How early should I book a snowbird car shipment?',
        a: 'We recommend booking 2–3 weeks in advance during peak season (Oct–Dec southbound, Mar–May northbound). Excelence Inc holds dedicated capacity for repeat snowbird clients.',
      },
    ],
  },
  {
    slug: 'california',
    name: 'California',
    abbr: 'CA',
    intro:
      'Los Angeles, San Francisco, San Diego, Sacramento — California\u2019s long coastline and huge dealer network mean constant vehicle movement. Excelence Inc covers every major California lane with professional carriers and 24/7 dispatch support.',
    cities: ['Los Angeles', 'San Francisco', 'San Diego', 'Sacramento', 'San Jose', 'Oakland', 'Long Beach', 'Fresno'],
    routes: [
      { from: 'California', to: 'Texas', miles: '~1,500', days: '3–5' },
      { from: 'California', to: 'New York', miles: '~2,800', days: '7–10' },
      { from: 'California', to: 'Florida', miles: '~2,700', days: '7–9' },
      { from: 'California', to: 'Arizona', miles: '~380', days: '1–2' },
      { from: 'California', to: 'Nevada', miles: '~270', days: '1–2' },
    ],
    faqs: [
      {
        q: 'How much does it cost to ship a car from California to the East Coast?',
        a: 'California to East Coast car shipping typically costs $1,100–$1,900 for open transport and $1,800–$2,800 for enclosed. Distance and vehicle type drive the final price — use our instant estimator for an exact number.',
      },
      {
        q: 'Do you ship cars to and from Los Angeles?',
        a: 'Yes — LA is a core hub with daily dispatch windows. Pickup typically within 24–48 hours of booking, direct to any California ZIP.',
      },
      {
        q: 'Can you transport Teslas and EVs in California?',
        a: 'Yes, we transport all EVs including Tesla Model S/3/X/Y, Rivian, Lucid and Ford Mach-E with trained drivers who understand low-voltage loading and handling.',
      },
      {
        q: 'Do you handle dealer transports in California?',
        a: 'Yes — Excelence Inc is a preferred partner for California dealerships and auction houses. Net terms available for volume clients.',
      },
    ],
  },
  {
    slug: 'new-york',
    name: 'New York',
    abbr: 'NY',
    intro:
      'From NYC to Buffalo, Albany to Long Island — Excelence Inc is a New York-headquartered auto transport company with deep knowledge of the tri-state area. Narrow streets, tight pickup windows, dealer pressure — we\u2019ve seen it all.',
    cities: ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse', 'Yonkers', 'Long Island', 'Brooklyn'],
    routes: [
      { from: 'New York', to: 'Florida', miles: '~1,280', days: '3–5' },
      { from: 'New York', to: 'California', miles: '~2,800', days: '7–10' },
      { from: 'New York', to: 'Texas', miles: '~1,750', days: '4–6' },
      { from: 'New York', to: 'Illinois', miles: '~800', days: '2–3' },
      { from: 'New York', to: 'Georgia', miles: '~900', days: '2–3' },
    ],
    faqs: [
      {
        q: 'Can you pick up cars in New York City?',
        a: 'Yes — we coordinate NYC pickups with driver-friendly meeting points (wider streets, parking lots) to avoid congestion. We cover all 5 boroughs plus Long Island and Westchester.',
      },
      {
        q: 'How much does car shipping cost from New York to Florida?',
        a: 'NY → FL car shipping typically costs $700–$1,100 for open transport on this highly competitive lane. Snowbird season pricing fluctuates — book early for best rates.',
      },
      {
        q: 'Do you ship classic and luxury cars out of New York?',
        a: 'Yes. We run enclosed transport for New York collectors, dealers and auction houses, including pickup from private garages, storage facilities and auction lots.',
      },
      {
        q: 'Are you licensed in New York?',
        a: 'Yes — Excelence Inc is FMCSA registered (MC1766140 · DOT4474028) and fully licensed to operate nationwide including all New York pickups and deliveries.',
      },
    ],
  },
  {
    slug: 'georgia',
    name: 'Georgia',
    abbr: 'GA',
    intro:
      'Atlanta is a critical Southeast hub for auto transport. Excelence Inc offers daily dispatch out of Atlanta, Savannah, Augusta and Columbus with dedicated capacity for dealers and auction houses.',
    cities: ['Atlanta', 'Savannah', 'Augusta', 'Columbus', 'Macon', 'Athens', 'Marietta', 'Sandy Springs'],
    routes: [
      { from: 'Georgia', to: 'Florida', miles: '~350', days: '1–2' },
      { from: 'Georgia', to: 'Texas', miles: '~800', days: '2–3' },
      { from: 'Georgia', to: 'New York', miles: '~900', days: '2–3' },
      { from: 'Georgia', to: 'California', miles: '~2,400', days: '6–8' },
      { from: 'Georgia', to: 'Illinois', miles: '~700', days: '2–3' },
    ],
    faqs: [
      {
        q: 'How much does car shipping cost in Georgia?',
        a: 'Most Georgia auto transport jobs range $400–$1,000 depending on distance. Atlanta is our busiest Southeast pickup point with same-day dispatch availability.',
      },
      {
        q: 'Do you handle Atlanta dealer transports?',
        a: 'Yes — we serve dealerships and auction lots across metro Atlanta with recurring routes and volume pricing.',
      },
      {
        q: 'Can you ship cars from Georgia to Florida?',
        a: 'Yes — GA → FL is one of our shortest, most cost-effective lanes. Typical transit 1–2 days with daily availability.',
      },
      {
        q: 'Do you offer enclosed transport in Georgia?',
        a: 'Yes. Enclosed transport is available throughout Georgia for luxury, classic and collector vehicles — with climate-controlled trailers when required.',
      },
    ],
  },
  {
    slug: 'arizona',
    name: 'Arizona',
    abbr: 'AZ',
    intro:
      'Phoenix, Tucson, Scottsdale — Arizona is a key Southwest corridor and one of the most popular snowbird destinations in the country. Excelence Inc offers competitive rates and fast dispatch on every Arizona lane.',
    cities: ['Phoenix', 'Tucson', 'Mesa', 'Scottsdale', 'Chandler', 'Glendale', 'Gilbert', 'Tempe'],
    routes: [
      { from: 'Arizona', to: 'California', miles: '~380', days: '1–2' },
      { from: 'Arizona', to: 'Texas', miles: '~1,000', days: '2–3' },
      { from: 'Arizona', to: 'Florida', miles: '~2,100', days: '5–7' },
      { from: 'Arizona', to: 'Nevada', miles: '~300', days: '1–2' },
      { from: 'Arizona', to: 'New York', miles: '~2,400', days: '6–9' },
    ],
    faqs: [
      {
        q: 'How much does it cost to ship a car to Arizona?',
        a: 'Arizona car shipping costs $400–$1,400 depending on origin. Phoenix is our main hub with strong outbound and inbound capacity year-round.',
      },
      {
        q: 'Do you ship cars from Arizona to California?',
        a: 'Yes — AZ → CA is one of the most active regional lanes with next-day pickup available. Typical rate $300–$500 for open transport.',
      },
      {
        q: 'Can you handle snowbird shipments to Arizona?',
        a: 'Absolutely. We run dedicated snowbird lanes to Scottsdale, Tucson and greater Phoenix every fall and spring. Book 2–3 weeks ahead for best rates.',
      },
      {
        q: 'Do you deliver to remote AZ destinations?',
        a: 'Yes — we deliver to every ZIP in Arizona including Flagstaff, Sedona, Yuma and tribal areas. Rural delivery fees apply to isolated locations.',
      },
    ],
  },
  {
    slug: 'illinois',
    name: 'Illinois',
    abbr: 'IL',
    intro:
      'Chicago is the Midwest\u2019s largest auto transport hub. Excelence Inc serves every Illinois market — from O\u2019Hare-area dealerships to downstate Springfield — with daily dispatch and direct lanes to all 50 states.',
    cities: ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield', 'Peoria', 'Elgin'],
    routes: [
      { from: 'Illinois', to: 'Texas', miles: '~950', days: '2–3' },
      { from: 'Illinois', to: 'Florida', miles: '~1,200', days: '3–5' },
      { from: 'Illinois', to: 'California', miles: '~2,000', days: '5–7' },
      { from: 'Illinois', to: 'New York', miles: '~800', days: '2–3' },
      { from: 'Illinois', to: 'Georgia', miles: '~700', days: '2–3' },
    ],
    faqs: [
      {
        q: 'How much does car shipping cost in Illinois?',
        a: 'Illinois auto transport rates typically range $500–$1,300 depending on distance and trailer type. Chicago offers the most competitive pricing thanks to high carrier density.',
      },
      {
        q: 'Do you serve Chicago dealer transports?',
        a: 'Yes — we\u2019re active with Chicago-area dealerships and auction lots. Net terms and recurring-lane pricing available for volume partners.',
      },
      {
        q: 'Can you pick up in downtown Chicago?',
        a: 'Yes, but we typically coordinate driver-friendly pickup points outside the Loop for faster loading. We cover every Chicago ZIP plus all collar counties.',
      },
      {
        q: 'Do you ship cars from Illinois in winter?',
        a: 'Yes — we operate year-round including winter. Open transport remains fully available; enclosed is recommended for high-value vehicles during heavy salt season.',
      },
    ],
  },
  {
    slug: 'nevada',
    name: 'Nevada',
    abbr: 'NV',
    intro:
      'Las Vegas and Reno are busy corridors for both retail and dealer auto transport. Excelence Inc offers same-day dispatch to Nevada with fast turnarounds to neighboring California, Arizona and Utah.',
    cities: ['Las Vegas', 'Reno', 'Henderson', 'North Las Vegas', 'Sparks', 'Carson City', 'Boulder City', 'Mesquite'],
    routes: [
      { from: 'Nevada', to: 'California', miles: '~270', days: '1–2' },
      { from: 'Nevada', to: 'Arizona', miles: '~300', days: '1–2' },
      { from: 'Nevada', to: 'Texas', miles: '~1,200', days: '3–4' },
      { from: 'Nevada', to: 'Florida', miles: '~2,500', days: '6–8' },
      { from: 'Nevada', to: 'New York', miles: '~2,500', days: '6–9' },
    ],
    faqs: [
      {
        q: 'How much does it cost to ship a car to Las Vegas?',
        a: 'Las Vegas car shipping costs $400–$1,500 depending on origin. LA to Vegas is one of our most affordable short-haul lanes — starting around $350 for open transport.',
      },
      {
        q: 'Do you ship cars from Las Vegas dealerships?',
        a: 'Yes — we work with Vegas dealers and auction lots with weekly dispatch schedules. Recurring-lane pricing available.',
      },
      {
        q: 'Can you deliver enclosed transport to Nevada?',
        a: 'Yes, enclosed transport is available across Nevada for luxury and exotic vehicles — ideal for Vegas\u2019s large collector and entertainment industry.',
      },
      {
        q: 'Do you cover Reno and Lake Tahoe?',
        a: 'Yes, we cover all Nevada ZIPs including Reno, Sparks, Carson City and Lake Tahoe destinations. Seasonal routes also available in winter.',
      },
    ],
  },
];

export const findStateBySlug = (slug) => STATE_PAGES.find((s) => s.slug === slug);
